import React from 'react';

//Estilos
import './NewDJCV.css';
import TableContainer from '../../components/table/TableContainer';

function NewDJCV({ functions, states }) {
    const { tableData, DJCVData } = states;

    const { handleSubmit, onSubmit } = functions;

    return (
        <div className="newDJCV-container">
            <form className="newDJCV-form" onSubmit={handleSubmit(onSubmit)}>
                <h4>
                    {`Declaración Jurada de Cancelación de Viñedo ${DJCVData?.cabecera?.serie}-P-${DJCVData?.cabecera?.numero}${DJCVData?.cabecera?.viniedo}`}
                </h4>
                <TableContainer tableData={tableData} />
                <div className="newDJCV-footer">
                    <button
                        type="submit"
                        className="btn btn-primary btn-submit-newDJCV"
                    >
                        Guardar
                    </button>
                </div>
            </form>
        </div>
    );
}

export default NewDJCV;
